import { history } from '@ers/helpers';
import { formatErrorMessage } from '.';

class RequestError extends Error {
    constructor(error, url) {
        let message = '';
        let status;
        if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            message = `Request error occured.
            Data:
            ${error.response.data}
            Status:
            ${error.response.status}
            Headers:
            ${error.response.headers}`;
            status = error.response.status;
            history.goToError(status);
        } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            message = error.request;
        } else {
            message = error.message;
        }
        super(...formatErrorMessage(message));
        Error.captureStackTrace(this, RequestError);
        this.message = message;
        this.status = status;
        this.url = url;
        history.goToError(status);
    }
}

export default RequestError;
